(() => {
  class FeelRegionSelector extends HTMLElement {
    constructor() {
      super();

      this.handleTriggerClick =
        this.handleTriggerClick.bind(this);

      this.handleOptionClick =
        this.handleOptionClick.bind(this);

      this.handleLanguageOptionClick =
        this.handleLanguageOptionClick.bind(this);

      this.handleTabClick =
        this.handleTabClick.bind(this);

      this.handleDocumentClick =
        this.handleDocumentClick.bind(this);

      this.handleKeydown =
        this.handleKeydown.bind(this);
    }

    connectedCallback() {
      if (this.dataset.regionInitialized === 'true') {
        return;
      }

      this.dataset.regionInitialized = 'true';

      this.form = this.querySelector('form');

      this.trigger = this.querySelector(
        '[data-region-trigger]'
      );

      this.dropdown = this.querySelector(
        '[data-region-dropdown]'
      );

      this.input = this.querySelector(
        '[data-region-input]'
      );

      this.options = this.querySelectorAll(
        '[data-region-value]'
      );

      this.languageInput = this.querySelector(
        '[data-language-input]'
      );

      this.languageOptions = this.querySelectorAll(
        '[data-language-value]'
      );

      this.tabs = this.querySelectorAll(
        '[data-region-tab]'
      );

      this.panels = this.querySelectorAll(
        '[data-region-panel]'
      );

      if (
        !this.form ||
        !this.trigger ||
        !this.dropdown ||
        !this.input
      ) {
        return;
      }

      this.trigger.addEventListener(
        'click',
        this.handleTriggerClick
      );

      this.options.forEach((option) => {
        option.addEventListener(
          'click',
          this.handleOptionClick
        );
      });

      this.languageOptions.forEach((option) => {
        option.addEventListener(
          'click',
          this.handleLanguageOptionClick
        );
      });

      this.tabs.forEach((tab) => {
        tab.addEventListener(
          'click',
          this.handleTabClick
        );
      });

      document.addEventListener(
        'click',
        this.handleDocumentClick
      );

      document.addEventListener(
        'keydown',
        this.handleKeydown
      );
    }


    disconnectedCallback() {
      if (this.trigger) {
        this.trigger.removeEventListener(
          'click',
          this.handleTriggerClick
        );
      }

      if (this.options) {
        this.options.forEach((option) => {
          option.removeEventListener(
            'click',
            this.handleOptionClick
          );
        });
      }

      if (this.languageOptions) {
        this.languageOptions.forEach((option) => {
          option.removeEventListener(
            'click',
            this.handleLanguageOptionClick
          );
        });
      }

      if (this.tabs) {
        this.tabs.forEach((tab) => {
          tab.removeEventListener(
            'click',
            this.handleTabClick
          );
        });
      }

      document.removeEventListener(
        'click',
        this.handleDocumentClick
      );

      document.removeEventListener(
        'keydown',
        this.handleKeydown
      );
    }


    handleTriggerClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.classList.contains('is-open')) {
        this.close();
      } else {
        this.closeOtherSelectors();
        this.open();
      }
    }


    handleOptionClick(event) {
      event.preventDefault();

      const option = event.currentTarget;

      const countryCode =
        option.dataset.regionValue;

      if (!countryCode) {
        return;
      }

      if (countryCode === this.input.value) {
        this.close();
        return;
      }

      this.input.value = countryCode;

      this.close();

      this.form.submit();
    }


    handleLanguageOptionClick(event) {
      event.preventDefault();

      const option = event.currentTarget;

      const languageCode =
        option.dataset.languageValue;

      if (!languageCode || !this.languageInput) {
        return;
      }

      if (languageCode === this.languageInput.value) {
        this.close();
        return;
      }

      this.languageInput.value = languageCode;

      this.close();

      this.form.submit();
    }


    handleTabClick(event) {
      event.preventDefault();

      const tab = event.currentTarget;

      const target = tab.dataset.regionTab;

      if (!target) {
        return;
      }

      this.tabs.forEach((t) => {
        const isActive = t === tab;

        t.classList.toggle('is-active', isActive);

        t.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );
      });

      this.panels.forEach((panel) => {
        const isActive =
          panel.dataset.regionPanel === target;

        panel.classList.toggle('is-active', isActive);

        panel.hidden = !isActive;
      });
    }


    handleDocumentClick(event) {
      if (this.contains(event.target)) {
        return;
      }

      this.close();
    }


    handleKeydown(event) {
      if (event.key !== 'Escape') {
        return;
      }

      if (!this.classList.contains('is-open')) {
        return;
      }

      this.close();

      this.trigger.focus();
    }


    open() {
      this.classList.add('is-open');

      this.dropdown.hidden = false;

      this.trigger.setAttribute(
        'aria-expanded',
        'true'
      );
    }


    close() {
      this.classList.remove('is-open');

      this.dropdown.hidden = true;

      this.trigger.setAttribute(
        'aria-expanded',
        'false'
      );
    }


    closeOtherSelectors() {
      document
        .querySelectorAll('feel-region-selector.is-open')
        .forEach((selector) => {
          if (
            selector !== this &&
            typeof selector.close === 'function'
          ) {
            selector.close();
          }
        });
    }
  }


  if (
    !customElements.get('feel-region-selector')
  ) {
    customElements.define(
      'feel-region-selector',
      FeelRegionSelector
    );
  }
})();
